import ApiHandler from './ApiHandler'

export default {
  uploadFile: data => ApiHandler.post('upload', data)
}
